module.exports = "/images/vendor/flag-icon-css/flags/1x1/om.svg?b9b7d0bc1d35b84b9e66f3f49f8bef3f";